import React from "react"
interface filterButtonProps {
  handleFilterSidebar?: () => void
}

const FilterIcon: React.FC<filterButtonProps> = (props) => {
  const { handleFilterSidebar } = props
  return (
    <button className="button tertiary icon-left" onClick={handleFilterSidebar}>
      <i className="icon-font tc-icon-filter"></i>
      <span>Filter</span>
    </button>
  )
}

export default FilterIcon
